export interface SearchableParticipant {
    id: string | number
    user_id?: string | number
    name: string
    email: string
}

export function matchesParticipantId(participant: SearchableParticipant, userId?: string | null) {
    if (!userId) return false

    return [participant.id, participant.user_id]
        .some((value) => value != null && String(value) === String(userId))
}

export function filterParticipants<T extends SearchableParticipant>(
    participants: T[],
    search: string,
    targetUserId?: string | null,
) {
    if (targetUserId) {
        return participants.filter((participant) => matchesParticipantId(participant, targetUserId))
    }

    const normalizedSearch = search.trim().toLowerCase()
    if (!normalizedSearch) return participants

    return participants.filter((participant) => (
        participant.name.toLowerCase().includes(normalizedSearch)
        || participant.email.toLowerCase().includes(normalizedSearch)
    ))
}

export function getParticipantSearchLabel(participant: SearchableParticipant) {
    return participant.email || participant.name
}
